.scroll-stack-scroller {
	position: relative;
	width: 100%;
	height: 100%;
	overflow-y: auto;
	overflow-x: visible;
	overscroll-behavior: contain;
	-webkit-overflow-scrolling: touch;
	scroll-behavior: smooth;
	-webkit-transform: translateZ(0);
	transform: translateZ(0);
	will-change: scroll-position;
}

/* Main document scroll — Lenis drives window; no nested scrollport */
.scroll-stack-scroller.scroll-stack-scroller--window {
	height: auto;
	overflow: visible;
	overscroll-behavior: auto;
	-webkit-overflow-scrolling: auto;
	scroll-behavior: auto;
	will-change: auto;
}

.scroll-stack-inner {
	padding: 20vh 5rem 50rem;
	min-height: 100vh;
}

.scroll-stack-scroller--window .scroll-stack-inner {
	padding-top: 66px;
	/* Fixed px so space below stack matches on all viewports (vh/clamp varied too much). */
	padding-bottom: 160px;
	min-height: 0;
}

/* Pin release uses this node’s offset — fixed runway, same every device. */
.scroll-stack-scroller--window .scroll-stack-end {
	margin-top: 280px;
	height: 1px;
}

@media (max-width: 782px) {
	.scroll-stack-inner {
		padding-left: 1.25rem;
		padding-right: 1.25rem;
	}

	.scroll-stack-scroller--window .scroll-stack-inner {
		padding-top: 40px;
		padding-bottom: 0;
	}

	/* No scroll runway needed on mobile — pin animation is disabled */
	.scroll-stack-scroller--window .scroll-stack-end {
		margin-top: 0;
	}
}

.scroll-stack-card-wrapper {
	position: relative;
}

.scroll-stack-card {
	transform-origin: top center;
	will-change: transform, filter;
	backface-visibility: hidden;
	transform-style: preserve-3d;
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.1);
	height: 20rem;
	width: 100%;
	margin: 14px 0;
	padding: 3rem;
	border-radius: 40px;
	box-sizing: border-box;
	-webkit-transform: translateZ(0);
	transform: translateZ(0);
	position: relative;
}

.scroll-stack-end {
	width: 100%;
	height: 1px;
}